import { c as _c } from "react/compiler-runtime";
import { SiClaude, SiGooglegemini, SiPerplexity } from "react-icons/si";
import { RiGrokAiLine, RiOpenaiLine } from "react-icons/ri";
const prompt = encodeURIComponent("Evaluate The Dezine (https://www.thedezine.in) as a technology partner. Review its web and mobile app development, eCommerce, UI/UX design, AI solutions, digital marketing, and custom software services. Based on its website and portfolio, highlight its strengths, the business challenges it could address, and the outcomes it could support. Explain which businesses and projects would be a strong fit, and ask about my requirements to assess its suitability.");
const providers = [{
  name: "Claude",
  icon: SiClaude,
  href: `https://claude.ai/new?q=${prompt}`
}, {
  name: "ChatGPT",
  icon: RiOpenaiLine,
  href: `https://chatgpt.com/?q=${prompt}`
}, {
  name: "Google AI Mode",
  icon: SiGooglegemini,
  href: `https://www.google.com/search?udm=50&aep=11&q=${prompt}`
}, {
  name: "Grok",
  icon: RiGrokAiLine,
  href: `https://grok.com/?q=${prompt}`
}, {
  name: "Perplexity",
  icon: SiPerplexity,
  href: `https://www.perplexity.ai/search?q=${prompt}`
}];
const iconLayerClassName = "absolute inset-0 flex items-center justify-center motion-safe:transition-transform motion-safe:duration-500 motion-safe:ease-in-out";
export default function FooterAiLinks() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="font-poppins text-base font-semibold text-primary dark:text-white">Hear It From AI.</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-wrap items-center justify-center gap-3 text-primary lg:justify-start dark:text-white">{t0}<div className="flex flex-wrap items-center justify-center gap-2">{providers.map(_temp)}</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(t0) {
  const {
    name,
    icon: Icon,
    href
  } = t0;
  return <a key={name} href={href} target="_blank" rel="noopener noreferrer" aria-label={`Open ${name} in a new tab`} title={name} className="group relative size-11 shrink-0 overflow-hidden rounded-md border border-violet-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-500 dark:border-gray-600"><span aria-hidden="true" className={`${iconLayerClassName} motion-safe:group-hover:-translate-y-full motion-safe:group-focus-visible:-translate-y-full`}><Icon className="size-6" /></span><span aria-hidden="true" className={`${iconLayerClassName} translate-y-full motion-safe:group-hover:translate-y-0 motion-safe:group-focus-visible:translate-y-0 motion-reduce:hidden`}><Icon className="size-6" /></span></a>;
}